import React, { useEffect, createElement } from 'react';
import { SalesPage } from './components/SalesPage';
import { CountdownTimer } from './components/CountdownTimer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  useEffect(() => {
    // Set page title
    document.title = 'Manual Académico Seguridad e Higiene';
    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;
    if (existingFavicon) {
      existingFavicon.href = 'https://cdn.magicpatterns.com/uploads/9GXHsbWusbbrKtHZ47HVnn/3.png';
    } else {
      const favicon = document.createElement('link');
      favicon.rel = 'icon';
      favicon.type = 'image/png';
      favicon.href = 'https://cdn.magicpatterns.com/uploads/9GXHsbWusbbrKtHZ47HVnn/3.png';
      document.head.appendChild(favicon);
    }
    // Meta Pixel Code
    const script = document.createElement('script');
    script.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '2020793225485829');
      fbq('track', 'PageView');
    `;
    document.head.appendChild(script);
    // Noscript pixel
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=2020793225485829&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    return () => {
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);
  return <div className="min-h-screen bg-white" data-id="element-0">
      <CountdownTimer data-id="element-1" />
      <SalesPage data-id="element-2" />
      <SocialProofPopup data-id="element-3" />
    </div>;
}